import { formatCents } from '@sifly/shared-utils'

/**
 * Bundle money, formatted the way the customer sees it everywhere else.
 *
 * NOT `formatPrice`: that always renders two decimals, so `/build` quoted
 * "$6,190.00" for the same board the PDP two clicks away shows as "$6,190".
 * The rule for customer-facing surfaces is whole dollars, with cents only when
 * genuinely non-zero — which is exactly what `formatCents` does. It takes
 * CENTS, hence the ×100; every amount on this route is dollars.
 *
 * Lives in its own module because both the server page and the client island
 * render prices, and a money formatter is the last thing that should exist in
 * two copies.
 */
export function money(dollars: number): string {
  return formatCents(Math.round(dollars * 100))
}
